import Vue from 'vue'
import Router from 'vue-router'

// in development-env not use lazy-loading, because lazy-loading too many pages will cause webpack hot update too slow. so only in production use lazy-loading;
// detail: https://panjiachen.github.io/vue-element-admin-site/#/lazy-loading

Vue.use(Router)

/* Layout */
import Layout from '../views/layout/Layout'
/**
* hidden: true                   if `hidden:true` will not show in the sidebar(default is false)
* alwaysShow: true               if set true, will always show the root menu, whatever its child routes length
*                                if not set alwaysShow, only more than one route under the children
*                                it will becomes nested mode, otherwise not show the root menu
* redirect: noredirect           if `redirect:noredirect` will no redirct in the breadcrumb
* name:'router-name'             the name is used by <keep-alive> (must set!!!)
* meta : {
    title: 'title'               the name show in submenu and breadcrumb (recommend set)
    icon: 'svg-name'             the icon show in the sidebar,
  }
**/
export const constantRouterMap = [
  { path: '/login', component: () => import('@/views/login/index'), hidden: true },
  { path: '/login/user', component: () => import('@/views/login-user/index'), hidden: true },
  { path: '/404', component: () => import('@/views/404'), hidden: true }
]

export default new Router({
  // mode: 'history',
  scrollBehavior: () => ({ y: 0 }),
  routes: constantRouterMap
})

export const asyncRouterMap = [
  {
    path: '',
    component: Layout,
    redirect: 'index',
    children: [{
      path: 'index',
      name: 'Certificates',
      component: () => import('@/views/certificates/index'),
      meta: {
        title: 'Certificates',
        icon: 'copy',
        special: true
      }
    }]
  },
  {
    path: '/distributor',
    component: Layout,
    // redirect: '/dashboard',
    hidden: true,
    children: [{
      path: 'index',
      name: 'Distributors',
      component: () => import('@/views/distributor/index'),
      meta: { title: 'Distributors', icon: 'excel' }
    },
    {
      path: ':distributor_id(\\d+)/assets',
      name: 'Distributor - Assets',
      component: () => import('@/views/asset/index'),
      meta: { title: 'Assets', icon: 'table', noCache: true },
      hidden: true
    },
    {
      path: ':distributor_id(\\d+)/batch/:batch_id(\\d+)/assets',
      name: 'Distributor - Assets By Batch',
      component: () => import('@/views/asset/index'),
      meta: { title: 'Assets', icon: 'table', noCache: true },
      hidden: true
    }]
  },
  {
    path: '/batch',
    component: Layout,
    // redirect: '/dashboard',
    hidden: true,
    children: [{
      path: 'index',
      name: 'Batches',
      component: () => import('@/views/batch/index'),
      meta: { title: 'Batches', icon: 'list' }
    },
    {
      path: ':batch_id(\\d+)/assets',
      name: 'Assets',
      component: () => import('@/views/asset/index'),
      meta: { title: 'Assets', icon: 'list', noCache: true },
      hidden: true
    }]
  },
  {
    path: '/products',
    component: Layout,
    children: [{
      path: 'index',
      name: 'Products',
      component: () => import('@/views/product/index'),
      meta: { title: 'Products', icon: 'grid', special: true }
    },
    {
      path: ':product_id(\\d+)/assets',
      name: 'Products - Assets',
      component: () => import('@/views/asset/index'),
      meta: { title: 'Assets', icon: 'table', noCache: true },
      hidden: true
    }]
  },
  {
    path: '/asset',
    component: Layout,
    // redirect: '/dashboard',
    // hidden: true,
    children: [{
      path: 'index',
      name: 'Asset',
      component: () => import('@/views/asset/index'),
      meta: { title: 'Assets Explorer', icon: 'calendar', special: true }
    }]
  },
  {
    path: '/activities',
    component: Layout,
    // redirect: '/dashboard',
    // hidden: true,
    children: [{
      path: 'index',
      name: 'Activities',
      component: () => import('@/views/activities/index'),
      meta: { title: 'Activities Explorer', icon: 'list', special: true }
    }]
  },
  {
    path: '/report',
    component: Layout,
    // redirect: '/dashboard',
    // hidden: true,
    children: [{
      path: 'index',
      name: 'Report',
      component: () => import('@/views/report/index'),
      meta: { title: 'Report', icon: 'fileText', special: true }
    }]
  },
  {
    path: '/profile',
    component: Layout,
    // redirect: '/dashboard',
    // hidden: true,
    children: [{
      path: 'index',
      name: 'Profile',
      component: () => import('@/views/profile/index'),
      meta: {
        title: 'Profile',
        icon: 'user',
        special: true
      }
    }]
  },
  {
    path: '/user',
    component: Layout,
    // redirect: '/dashboard',
    // hidden: true,
    children: [{
      path: 'index',
      name: 'User',
      component: () => import('@/views/user/index'),
      meta: { title: 'User Management', icon: 'settings', special: true }
    }]
  },
  {
    path: '/change-password',
    component: Layout,
    hidden: true,
    meta: { },
    children: [{
      path: '',
      name: 'Change Password',
      component: () => import('@/views/changePassword/index'),
      meta: { title: 'Change Password', icon: 'form' }
    }]
  },
  { path: '*', redirect: '/404', hidden: true }
]

export const userRouterMap = [
  {
    path: '',
    component: Layout,
    redirect: 'index',
    // hidden: true,
    children: [{
      path: 'index',
      name: 'Action',
      component: () => import('@/views/action/index'),
      meta: {
        title: 'Action',
        icon: 'cloud-lightning',
        special: true
      }
    }]
  },
  {
    path: '/profile',
    component: Layout,
    // redirect: '/dashboard',
    // hidden: true,
    children: [{
      path: 'index',
      name: 'Profile',
      component: () => import('@/views/profile/index'),
      meta: {
        title: 'Profile',
        icon: 'user',
        special: true
      }
    }]
  },
  {
    path: '*',
    redirect: '/404',
    hidden: true
  }
]



// WEBPACK FOOTER //
// ./src/router/index.js